module.exports = __webpack_public_path__ + "static/barra-prr-303ed59584c130aa0dd07c393251eaf1.png";